import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function useSubscriptionList() {
  const navigate = useNavigate();

  const handleDetail = useCallback(
    (subscriptionId: number) => {
      navigate(`/subscription/${subscriptionId}`);
    },
    [navigate]
  );

  return {
    handleDetail,
  };
}
